import { Injectable } from '@angular/core';

/*
  Generated class for the UploadHelperProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()

export class UploadHelperProvider {

  private uploadUrl = 'https://tool.vggo.be/index.php?p=actions/vggo/app/saveImgForLot2&id=';
  // private uploadUrl = 'http://staging.vggo.be/index.php?p=actions/vggo/app/saveImgForLot&id=';
  private key = 'ahiR4Mt8MPdOf12gKNFU0CAxpVfRN4kp';

  toJpegBlob(imageFile: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(imageFile);
      img.onload = () => {
        URL.revokeObjectURL(url);
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        canvas.toBlob(blob => {
          if (blob) resolve(blob);
          else reject(new Error('canvas toBlob failed'));
        }, 'image/jpeg', 0.85);
      };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('image load failed')); };
      img.src = url;
    });
  }

  uploadFile(lotId, imageFile: File): Promise<any> {
    return this.toJpegBlob(imageFile).then(jpegBlob => {
      const formData = new FormData();
      formData.append('key', this.key);
      formData.append('file', jpegBlob, Date.now() + '.jpg');
      console.log('uploading jpeg blob', jpegBlob.size, 'bytes');

      return fetch(this.uploadUrl + lotId + '&key=' + encodeURIComponent(this.key), {
        method: 'POST',
        body: formData,
      }).then(response => {
        return response.text().then(text => ({
          responseCode: response.status,
          response: text
        }));
      });
    }).catch(err => {
      console.error('upload error', err);
      return false;
    });
  }

  checkConnection(){
    return navigator.onLine;
  }
}



// WEBPACK FOOTER //
// ./src/providers/upload-helper/upload-helper.ts